import React from 'react';
import { Link } from 'react-router-dom';
import MainLayout from '../../layouts/MainLayout';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import {
  faLockOpen,
  faIdCard,
  faUsers,
  faPeopleGroup,
  faHeart,
  faProjectDiagram,
  faCogs,
  faMapMarkerAlt,
  faCalendarAlt,
  faListAlt,
  faUser,
  faKey,
  faCog,
  faTachometerAlt,
  faFileUpload,
  faImages,
  faStream,
  faTasks
} from '@fortawesome/free-solid-svg-icons';
import './StartupKitHome.css';
import DocumentList from './DocumentList';

function StartupKitHome() {
  return (
    <div className='text-white bg-black px-1'>
      <div className='border-b border-blue-400 mb-2'>
        <header className='bg-black flex flex-col justify-center text-center items-center'>
          <h1 className='bg-black text-yellow-200 text-lg lg:text-xl py-2 '>MSME Templates / Startup Bundle</h1>
          <div className='flex flex-row gap-4 text-xs lg:text-sm [&>p]:text-white'>
            <p className='text-sm lg:text-m'><a href="#home">Home</a></p>
            <p className='text-sm lg:text-m'><a href="#documents">Documents</a></p>
            <p className='text-sm lg:text-m'><a href="#about">About</a></p>
            <p className='text-sm lg:text-m'><a href="#pricing">Pricing</a></p>
          </div>
        </header>
      </div>
      {/* <section id="home" className="bg-black border border-gray-600">
        <h1 className='text-yellow-200 text-sm lg:text-m py-2'>Your Shortcut to MSEM & Startup Success</h1>
        <div className='flex flex-col items-center text-center'>
          <p className="text-xs lg:text-m font-medium text-white">
            Save time, avoid costly mistakes, and scale your business with over 200 expert-crafted documents.
          </p>
        </div>
      </section> */}
      <DocumentList />
      <footer className="bg-black border-t border-blue-400 text-white py-4">
        <div className="max-w-6xl mx-auto px-3 flex flex-col md:flex-row items-center justify-between gap-3">
          <div className="text-sm text-yellow-200">© 2025 Think5Whys Global DeepTech Solutions.</div>
          <div className="flex flex-wrap gap-4 text-sm">
            <Link to="/about-us" className="hover:text-teal-300">About</Link>
            <Link to="/privacy-policy" className="hover:text-teal-300">Privacy Policy</Link>
            <Link to="/terms-of-use" className="hover:text-teal-300">Terms of Use</Link>
            <Link to="/contact-us" className="hover:text-teal-300">Contact</Link>
          </div>
        </div>
      </footer>
    </div>
  );
}

export default StartupKitHome;
